import { render, staticRenderFns } from "./dunningCrud.vue?vue&type=template&id=9be1736c&"
import script from "./dunningCrud.vue?vue&type=script&lang=js&"
export * from "./dunningCrud.vue?vue&type=script&lang=js&"
import style0 from "./dunningCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports